/**
 * @generated SignedSource<<d63797724d5f9842c9a123a8b06c57e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditUserInfoModalFragment$data = {
  readonly viewer: {
    readonly user?: {
      readonly bio: string | null;
      readonly dbid: string;
      readonly username: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "EditUserInfoModalFragment";
};
export type EditUserInfoModalFragment$key = {
  readonly " $data"?: EditUserInfoModalFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditUserInfoModalFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditUserInfoModalFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GalleryUser",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dbid",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "username",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "bio",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "Viewer",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "2dc71f01d6028a17f4fd1d00b06e9157";

export default node;
